import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Inicio = () => import('@/views/Inicio')
const Error = () => import('@/views/Error')

//Views Mantención de Parámetros
const Proveedores = () => import('@/views/mantencion-de-parametros/Proveedores')
const CondicionVenta = () => import('@/views/mantencion-de-parametros/CondicionVenta')

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/403',
      name: 'Error',
      component: Error,
    },
    {
      path: '/',
      redirect: '/inicio',
      name: 'Inicio',
      component: DefaultContainer,
      children: [
        {
          path: 'inicio',
          name: '',
          component: Inicio
        },
        {
          path: '/mantencion-de-parametros',
          redirect: '/mantencion-de-parametros/proveedores',
          name: 'Proveedores',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'proveedores',
            name: 'Listado',
            component: Proveedores
          }
          ]
        },
        {
          path: '/mantencion-de-parametros',
          redirect: '/mantencion-de-parametros/condicionventa',
          name: 'CondicionVenta',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'condicionventa',
            name: 'Condición de Venta',
            component: CondicionVenta
          }
          ]
        }
      ]
    }
  ]
})
